import { EOrderDirectionType, EPageDimension, EPageMetric } from '~/core/gemxql/types';
import { EMetricKey } from '~/types/metric';

export const LISTING_METRICS = [EMetricKey.SESSION, EPageMetric.PAGE_ITEMS];
export const LISTING_DIMENSIONS = [EPageDimension.PAGE_PATH];
export const LISTING_ORDER_BY_SESSIONS_DESC = {
  [EMetricKey.SESSION]: { field: EMetricKey.SESSION, direction: EOrderDirectionType.DESC },
};
